<template>
    <div class='MarginCalculator'>
        <div class='col-2 Increment'>
            <button v-on:click='inc(currentValue, 1)' :class='{disabled: this.currentValue > 99}' class='btn btn-success inc-button'>
                <svg width="16px" height="16px" viewBox="0 0 16 16" class="bi bi-arrow-up-short" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"/>
                </svg>
            </button>
        </div>
        <div class='col-6 InputValue'>
            <label :for='getLabel' >{{ label }}</label>  
            <input :id='label' :placeholder='phvalue' :value='this.displayValue' @input='custom'>  
        </div>
        <div class='col-2 Decrement'>
             <button v-on:click='dec(currentValue, 1)' :class='{disabled: this.currentValue < 1}' class='btn btn-danger dec-button'>
                <svg width="16px" height="16px" viewBox="0 0 16 16" class="bi bi-arrow-down-short" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"/>
                </svg>
             </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MarginCalculator',
        props: ['label', 'value', 'store'],
        data() {
            return {
                getLabel: this.$props.label,
                propValue: this.$props.value
            }
        },
        computed: {
            displayValue() {
                return this.currentValue + '%'
            },
            currentValue() {
                return parseInt(this.$props.value)
            },
            phvalue(){
                return this.currentValue == '' ? 'Form Input' : this.currentValue
            }
        },
        methods: {
            inc(property, amt){
                if (this.$props.value === 100) return
                console.log(property)
                this.propValue = this.currentValue + amt
                let newValue = {
                    type: this.$props.label,
                    value: this.propValue
                }
                this.$store.dispatch(this.$props.store + '/calculatePrice', newValue)
            },
            dec(property, amt){
                console.log(property)
                if (this.$props.value === 0) return
                this.propValue = this.currentValue - amt
                let newValue = {
                    type: this.$props.label,
                    value: this.propValue
                }
                this.$store.dispatch(this.$props.store + '/calculatePrice', newValue)
            },
            custom(e){
                if((parseInt(e.target.value) < 100) && (parseInt(e.target.value) >= 0)){
                    this.propValue = parseInt(e.target.value);
                    let newValue = {
                        type: this.$props.label,
                        value: this.propValue
                    }
                    this.$store.dispatch(this.$props.store + '/calculatePrice', newValue)
                }
            }
        }
    }
</script>